import styled, { keyframes } from "styled-components";

const scaleIn = keyframes`
  from { opacity: 0; transform: scale(0.9) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.7); /* Azul escuro semi-transparente */
  backdrop-filter: blur(4px); /* Efeito de desfoque no fundo */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Content = styled.div`
  background: var(--surface);
  width: 100%;
  max-width: 450px;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: ${scaleIn} 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  border: 1px solid var(--border);

  header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    margin-bottom: 24px;

    .icon-box {
      width: 64px;
      height: 64px;
      background: #fef2f2;
      color: var(--primary);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h3 {
      font-size: 1.5rem;
      color: var(--text-main);
      font-weight: 800;
      margin: 0;
    }
  }

  p {
    color: var(--text-secondary);
    text-align: center;
    line-height: 1.6;
    margin-bottom: 32px;
    font-size: 1rem;

    strong {
      color: var(--text-main);
      font-weight: 700;
      display: block;
      margin-top: 4px;
      font-size: 1.1rem;
    }
  }

  .modal-actions {
    display: flex;
    gap: 12px;

    button {
      flex: 1;
      height: 52px;
      border-radius: 12px;
      font-weight: 800;
      cursor: pointer;
      transition: all 0.2s ease;
      text-transform: uppercase;
      font-size: 0.85rem;
      letter-spacing: 0.5px;
    }

    .cancel-btn {
      background: var(--background);
      color: var(--text-secondary);
      border: 1px solid var(--border);

      &:hover {
        background: var(--border);
        color: var(--text-main);
      }
    }

    .confirm-btn {
      background: var(--primary); /* Vermelho Ninja */
      color: white;
      border: none;

      &:hover {
        filter: brightness(0.9);
        transform: translateY(-2px);
        box-shadow: 0 8px 15px rgba(231, 76, 60, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  /* Botão X de fechar no canto superior */
  .close-x {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    color: var(--text-secondary);
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: var(--primary);
    }
  }
`;